import * as MUI from "@mui/material";

export const ResultadoDaConsulta: React.FC = ({ children }) => {
  const theme = MUI.useTheme();
  return (
    <MUI.Stack flex={1}>
      <MUI.Stack mb={2}>
        <MUI.Stack mb={1} flexDirection="row" flexWrap="wrap">
          <MUI.Stack flexDirection="row" justifyContent="left">
            <MUI.Typography
              fontWeight="bold"
              variant="body1"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              RESULTADO DA CONSULTA
            </MUI.Typography>
          </MUI.Stack>
        </MUI.Stack>
        <MUI.Divider
          sx={{
            borderWidth: 2,
            backgroundColor: `${theme.palette.secondary.contrastText}`,
          }}
        />
      </MUI.Stack>

      <MUI.Stack mt={1}>{children}</MUI.Stack>
    </MUI.Stack>
  );
};
